import React from 'react';
import { Property, Properties } from '@lib/state';
import { Typography, Divider, makeStyles, createStyles } from '@material-ui/core';
import { ContactDisplay, AddressDisplay } from '@lib/common';
import { AppColors } from '@lib/common/theme';

const useStyles = makeStyles(theme =>
  createStyles({
    propertyItem: {
      backgroundColor: theme.palette.grey[200],
      color: AppColors.DarkGray,
      padding: theme.spacing(2),
      height: '100%',
    },
    propertyHeader: {
      display: 'flex',
    },
    propertyTitle: {
      color: theme.palette.primary.main,
    },
    comingSoon: {
      backgroundColor: AppColors.Green,
      color: theme.palette.secondary.contrastText,
      borderRadius: '6px',
      padding: '0 0.5rem',
      marginLeft: '0.5rem',
    },
    divider: {
      margin: `${theme.spacing(1)}px 0`,
    },
  })
);

interface Props {
  property: Property;
}

export const PropertContact: React.FC<Props> = ({ property }) => {
  const isComingSoon = property.status === Properties.PropertyStatus.ComingSoon;
  const styles = useStyles({ isComingSoon });

  return (
    <div className={styles.propertyItem}>
      <div className={styles.propertyHeader}>
        <Typography variant="h6" className={styles.propertyTitle}>
          {property.name}, {property.location.state}
        </Typography>
        {isComingSoon && (
          <div className={styles.comingSoon}>
            <Typography variant="subtitle1">Coming Soon</Typography>
          </div>
        )}
      </div>
      <Divider className={styles.divider} />

      <AddressDisplay
        line1={property.location.line1}
        line2={property.location.line2}
        city={property.location.city}
        state={property.location.state}
        zip={property.location.zip}
      />
      <ContactDisplay email={property.contact?.email ?? ''} phone={property.contact?.phone ?? ''} />
      {(property.groupBooking?.phone || property.groupBooking?.email) && (
        <>
          <Divider className={styles.divider} />

          <Typography>For corporate / group bookings, please contact:</Typography>
          <ContactDisplay
            email={property.groupBooking?.email ?? ''}
            phone={property.groupBooking?.phone ?? ''}
          />
        </>
      )}
    </div>
  );
};
